/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Content, Overlay, Wrapper } from './styles';
import { notesConnectionFiltersEnum } from '../../constants/Filters';
import RangeDate from './RangeDate';
import Status from './Status';
import { getNoteList, changeFilters } from '../../../../redux/note-connection';

const ConnectionsFilter = ({ dispatch }) => {
  const [activeFilter, setActiveFilter] = useState(null);
  const [rangePeriodValue, setRangePeriodValue] = useState(null);
  const [statusValue, setStatusValue] = useState(null);

  const toggleFilter = filter => {
    setActiveFilter(activeFilter === filter ? null : filter);
  };

  const applyStatusFilter = status => {
    setStatusValue(status);
    dispatch(changeFilters({ status }));
    dispatch(getNoteList());
    toggleFilter(notesConnectionFiltersEnum.STATUS);
  };

  const applyRangePeriodFilter = ({
    initialPeriod,
    finalPeriod,
    displayValue,
  }) => {
    setRangePeriodValue(displayValue);
    dispatch(changeFilters({ initialPeriod, finalPeriod }));
    dispatch(getNoteList());

    toggleFilter(notesConnectionFiltersEnum.RANGE_PERIOD);
  };

  return (
    <Wrapper>
      <Content>
        {activeFilter && <Overlay onClick={() => toggleFilter(activeFilter)} />}
        <RangeDate
          onClick={() => toggleFilter(notesConnectionFiltersEnum.RANGE_PERIOD)}
          isOpen={activeFilter === notesConnectionFiltersEnum.RANGE_PERIOD}
          onApply={applyRangePeriodFilter}
          value={rangePeriodValue}
        />
        <Status
          onClick={() => toggleFilter(notesConnectionFiltersEnum.STATUS)}
          isOpen={activeFilter === notesConnectionFiltersEnum.STATUS}
          onApply={applyStatusFilter}
          value={statusValue}
        />
      </Content>
    </Wrapper>
  );
};

function mapStateToProps() {
  return;
}

export default connect(mapStateToProps)(ConnectionsFilter);
